import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import './GlobalSettings.scss'
import PointsSideModal from './components/PointSideModal'
import BadgesSideModal from './components/BadgesSideModal'
import BadgesSetDrawer from './components/BadgesSetDrawer'
import Levels from './components/Levels'
import Rewards from './components/Rewards'
import Statistics from './components/Statistics'
import { api } from '../../../../../../services'
import { useTranslation } from 'react-i18next'
const defaultPointRules = [
  { action_type: 'login', is_enabled: true, point_value: 0 },
  { action_type: 'quiz_complete', is_enabled: true, point_value: 0 },
  { action_type: 'lesson_complete', is_enabled: true, point_value: 0 },
  { action_type: 'get_certificate', is_enabled: true, point_value: 0 },
  { action_type: 'tip_approved', is_enabled: false, point_value: 0 },
  { action_type: 'tip_liked', is_enabled: false, point_value: 0 }
]
const GlobalSettings = () => {
  const [showPointsModal, setShowPointsModal] = useState(false)
  const [showBadgesSetDrawer, setShowBadgesSetDrawer] = useState(false)
  const [showLevelsModal, setShowLevelsModal] = useState(false)
  const [showRewardsModal, setShowRewardsModal] = useState(false)
  const [showStatisticsModal, setShowStatisticsModal] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [settingData, setSettingData] = useState({
    points_enabled: false,
    point_rules: defaultPointRules,
    badges_enabled: false,
    badge_rules: [
      { badge_id: null, is_enabled: true, min_point: 0, max_point: 100 }
    ],
    levels_enabled: false,
    level_rules: [
      { level_name: 'Level 1', is_enabled: true, min_point: 0, max_point: 100 }
    ]
  })
  const { t } = useTranslation()
  useEffect(() => {
    getGlobalSettings()
  }, [])
  const getGlobalSettings = async () => {
    setIsFetching(true)
    try {
      let res = await api.leaderboard.getGlobalSettings()
      let data = res.data
      if (data) {
        let convertedPointRules = data.point_rules
          ? data.point_rules.map(rule => {
              if (
                rule.min_point !== undefined &&
                rule.max_point !== undefined
              ) {
                return {
                  action_type: rule.action_type,
                  is_enabled: rule.is_enabled,
                  point_value: rule.max_point || 0
                }
              }
              return rule
            })
          : []

        // Ensure all default point rules are present
        defaultPointRules.forEach(defaultRule => {
          if (
            !convertedPointRules.some(
              r => r.action_type === defaultRule.action_type
            )
          ) {
            convertedPointRules.push(defaultRule)
          }
        })

        setSettingData({
          ...data,
          point_rules: convertedPointRules
        })
      } else {
        let res = await api.leaderboard.updateGlobalSettings()
        let data = res.data
        if (data) {
          let convertedPointRules = data.point_rules
            ? data.point_rules.map(rule => {
                if (
                  rule.min_point !== undefined &&
                  rule.max_point !== undefined
                ) {
                  return {
                    action_type: rule.action_type,
                    is_enabled: rule.is_enabled,
                    point_value: rule.max_point || 0
                  }
                }
                return rule
              })
            : []

          defaultPointRules.forEach(defaultRule => {
            if (
              !convertedPointRules.some(
                r => r.action_type === defaultRule.action_type
              )
            ) {
              convertedPointRules.push(defaultRule)
            }
          })

          setSettingData({
            ...data,
            point_rules: convertedPointRules
          })
        }
      }
    } catch (error) {
    } finally {
      setIsFetching(false)
    }
  }

  return (
    <div className="global-leaderboard-settings-list">
      <h2 className="leaderboard-settings-title">
        {t('v4:leaderboard_settings')}
      </h2>
      <div className="leaderboard-settings-desc">
        {t(
          'v4:set_up_engaging_leaderboard_experiences_to_boost_learner_motivation'
        )}
      </div>
      <Spin spinning={isFetching} tip="Loading settings...">
        <div className="settings-list">
          <div className="settings-item">
            <div className="settings-item-info">
              <div className="settings-item-title">{t('v4:points')}</div>
              <div className="settings-item-desc">
                {t(
                  'v4:award_users_with_points_for_different_learning_activities'
                )}
              </div>
            </div>
            <div className="settings-item-value-row">
              <span className="settings-item-value">
                {settingData.points_enabled
                  ? t('v4:enabled')
                  : t('v4:disabled')}
              </span>
              <button
                className="settings-item-arrow"
                onClick={() => setShowPointsModal(true)}
              >
                &gt;
              </button>
            </div>
          </div>

          <div className="settings-item">
            <div className="settings-item-info">
              <div className="settings-item-title">{t('v4:badge_set')}</div>
              <div className="settings-item-desc">
                {t('v4:choose_the_type_of_badges_your_users')}
              </div>
            </div>
            <div className="settings-item-value-row">
              <span className="settings-item-value">
                {settingData.badges_enabled
                  ? t('v4:enabled')
                  : t('v4:disabled')}
              </span>
              <button
                className="settings-item-arrow"
                onClick={() => setShowBadgesSetDrawer(true)}
              >
                &gt;
              </button>
            </div>
          </div>
          <div className="settings-item">
            <div className="settings-item-info">
              <div className="settings-item-title">{t('v4:levels')}</div>
              <div className="settings-item-desc">
                {t('v4:Levels_represent_the_stages')}
              </div>
            </div>
            <div className="settings-item-value-row">
              <span className="settings-item-value">
                {settingData.levels_enabled
                  ? t('v4:enabled')
                  : t('v4:disabled')}
              </span>
              <button
                className="settings-item-arrow"
                onClick={() => setShowLevelsModal(true)}
              >
                &gt;
              </button>
            </div>
          </div>
          {/* <div className="settings-item">
                      <div className="settings-item-info">
                          <div className="settings-item-title">Rewards</div>
                          <div className="settings-item-desc">Offer discounts when learners achieve a set of points, badges or levels.</div>
                      </div>
                      <div className="settings-item-value-row">
                          <span className="settings-item-value">{globalSettings.rewards ? 'Enabled' : 'Disabled'}</span>
                          <button className="settings-item-arrow" onClick={() => setShowBadgesModal(true)}>&gt;</button>
                      </div>
                  </div>
                  <div className="settings-item">
                      <div className="settings-item-info">
                          <div className="settings-item-title">Leaderboard Statistics</div>
                          <div className="settings-item-desc">Leaderboards offer users an overview of their learning progress in points compared to everyone else's.</div>
                      </div>
                      <div className="settings-item-value-row">
                          <span className="settings-item-value">{globalSettings.leaderboardStats ? 'Enabled' : 'Disabled'}</span>
                          <button className="settings-item-arrow" onClick={() => setShowStatisticsModal(true)}>&gt;</button>
                      </div>
                  </div> */}
        </div>
      </Spin>
      <PointsSideModal
        visible={showPointsModal}
        onClose={() => setShowPointsModal(false)}
        data={settingData}
        refreshData={getGlobalSettings}
      />
      {/* <BadgesSideModal visible={showBadgesModal} onClose={() => setShowBadgesModal(false)} /> */}
      <BadgesSetDrawer
        visible={showBadgesSetDrawer}
        onClose={() => setShowBadgesSetDrawer(false)}
        data={settingData}
        refreshData={getGlobalSettings}
      />
      <Levels
        visible={showLevelsModal}
        onClose={() => setShowLevelsModal(false)}
        data={settingData}
        refreshData={getGlobalSettings}
      />
      {/* <Rewards visible={showRewardsModal} onClose={() => setShowRewardsModal(false)} />
            <Statistics visible={showStatisticsModal} onClose={() => setShowStatisticsModal(false)} /> */}
    </div>
  )
}

export default GlobalSettings
